import type React from 'react';

export {
  MobileActionSheet,
  MobileListCard,
  MobilePageHeader,
  MobileSegmentedControl,
  MobileWizard,
} from '../../mobile';

export type LeagueCenterShellProps = {
  header: React.ReactNode;
  desktopNav: React.ReactNode;
  mobileNav: React.ReactNode;
  children: React.ReactNode;
};

export function LeagueCenterShell({ header, desktopNav, mobileNav, children }: LeagueCenterShellProps) {
  return (
    <div className="app-shell">
      {header}
      <div className="app-layout">
        {desktopNav}
        <main>{children}</main>
      </div>
      {mobileNav}
    </div>
  );
}
